import Vue from "vue";
import Router from "vue-router";
import Home from "./components/Home.vue";
import ViewImage from "./components/ViewImage.vue";
import SearchImages from "./components/SearchImages.vue";
import Collections from "./components/Collections.vue";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      component: Home
    },
    {
      path: "/viewimage/:imgUrl",
      name: "viewimage",
      component: ViewImage
    },
    {
      path: "/search/:search_q",
      name: "searchimages",
      component: SearchImages
    },
    {
      path: "/mycollections",
      name: "Collections",
      component: Collections
    }
  ]
});
